{
  "Your Stripe account, your branding, your price": "Dein Stripe-Konto, dein Branding, dein Preis",
  "Our fee is just US $1.50 per ticket sold (introductory offer)": "Unsere Gebühr beträgt nur 1,50 US-$ pro verkauftem Ticket (Einführungsangebot)",
  "All countries and 31 currencies supported": "Alle Länder und 31 Währungen werden unterstützt",
  "A fixed price, or let buyers choose the price": "Ein fester Preis – oder Käufer wählen den Preis selbst",
  "Coupons and other Stripe features": "Gutscheine und weitere Stripe-Funktionen",
  "Currency": "Währung",
  "Loading currencies…": "Währungen werden geladen…",
  "Amount": "Betrag",
  "Fee": "Gebühr",
  "{code} - {name} (No auto-conversion)": "{code} - {name} (keine automatische Umrechnung)",
  "Search currency...": "Währung suchen...",
  "Add currency": "Währung hinzufügen",
  "Single day {price} (24h access)": "Ein Tag {price} (24 Stunden Zugang)",
  "All {days} days {price}": "Alle {days} Tage {price}",
  "Livestream {price} (no replay)": "Livestream {price} (ohne Aufzeichnung)",
  "Livestream {price}": "Livestream {price}",
  "Livestream + Replay {price}": "Livestream + Aufzeichnung {price}",
  "+ video download add-on {price}": "+ optionaler Video-Download {price}",
  "+ service & processing fee at checkout": "+ Service- und Bearbeitungsgebühr bei der Bezahlung",
  "Video download {price} (live-only event — no replay)": "Video-Download {price} (Event nur live – keine Aufzeichnung)",
  "Nothing (live-only event with downloads off)": "Nichts (Event nur live, Downloads deaktiviert)",
  "Replay {price}": "Aufzeichnung {price}",
  "Replay + download": "Aufzeichnung + Download",
  "What buyers will see": "Das sehen Käufer",
  "Before & during the event: {items}": "Vor & während des Events: {items}",
  "After the event: {items}": "Nach dem Event: {items}",
  "Unlink Stripe Account": "Stripe-Konto trennen",
  "Are you sure you want to unlink your Stripe account? This will disable ticket sales for this event.": "Möchtest du dein Stripe-Konto wirklich trennen? Dadurch wird der Ticketverkauf für dieses Event deaktiviert.",
  "Failed to unlink Stripe account. Please try again.": "Das Stripe-Konto konnte nicht getrennt werden. Bitte versuch es noch einmal.",
  "Sell tickets": "Tickets verkaufen",
  "Couldn't load currencies": "Die Währungen konnten nicht geladen werden",
  "Check your connection and try again.": "Prüfe deine Verbindung und versuch es noch einmal.",
  "Guests pay to watch, and the money goes straight to your Stripe account.": "Gäste zahlen fürs Zusehen, und das Geld geht direkt auf dein Stripe-Konto.",
  "Tickets for rooms": "Tickets für Räume",
  "Connect Stripe account": "Stripe-Konto verbinden",
  "Copy link to connect Stripe": "Stripe-Link kopieren",
  "Send it to the Stripe account's owner.": "Schick ihn an die Person, der das Stripe-Konto gehört.",
  "Not your Stripe account? Send the link to its owner so they can connect it.": "Nicht dein Stripe-Konto? Schick den Link an die Person, der es gehört, damit sie es verbinden kann.",
  "Stripe fees, refunds and chargebacks are the connected account holder's responsibility. Need help setting up? Ask us in the support chat.": "Für Stripe-Gebühren, Rückerstattungen und Rückbuchungen ist der Inhaber des verbundenen Kontos verantwortlich. Brauchst du Hilfe bei der Einrichtung? Frag uns im Support-Chat.",
  "Stripe account connected": "Stripe-Konto verbunden",
  "Stripe dashboard": "Stripe-Dashboard",
  "Refresh": "Aktualisieren",
  "Unlink": "Trennen",
  "How guests pay": "So zahlen Gäste",
  "Disable Pay-Per-View": "Pay-per-View deaktivieren",
  "Use Existing Stripe Price": "Vorhandenen Stripe-Preis verwenden",
  "Custom Price (Fixed)": "Eigener Preis (fest)",
  "Customer Chooses Price": "Preis frei wählbar",
  "Choose how guests pay": "Wähle, wie Gäste zahlen",
  "Select Stripe Price": "Stripe-Preis auswählen",
  "price|None": "Keiner",
  "Custom Prices": "Eigene Preise",
  "This event is live-only, so the ticket includes the livestream only (no replay).": "Dieses Event ist nur live, daher enthält das Ticket nur den Livestream (keine Aufzeichnung).",
  "The ticket includes the livestream.": "Das Ticket enthält den Livestream.",
  "The ticket includes the livestream and the replay.": "Das Ticket enthält den Livestream und die Aufzeichnung.",
  "Set prices for each currency. First currency becomes the default.": "Lege Preise für jede Währung fest. Die erste Währung wird zum Standard.",
  "Sell single-day tickets": "Tagestickets verkaufen",
  "Your price above is the All-Days ticket. Set one price per day below — buyers choose which day. Single-day access lasts 24 hours from that day's scheduled start time.": "Dein Preis oben gilt für das Ticket für alle Tage. Lege unten einen Preis pro Tag fest – Käufer wählen den Tag. Der Zugang für einen Tag gilt 24 Stunden ab der geplanten Startzeit dieses Tages.",
  "Sell video download": "Video-Download verkaufen",
  "Buyers can add the downloadable video to any ticket for this amount.": "Käufer können das Video zum Herunterladen für diesen Betrag zu jedem Ticket hinzufügen.",
  "After the event it's sold on its own since this event is live-only.": "Nach dem Event wird es einzeln verkauft, da dieses Event nur live ist.",
  "After the event it's sold as Replay + Download.": "Nach dem Event wird es als „Aufzeichnung + Download“ verkauft.",
  "Single-day buyers can only download their day.": "Käufer eines Tagestickets können nur ihren Tag herunterladen.",
  "+ Set a different replay price after the event (optional)": "+ Anderen Preis für die Aufzeichnung nach dem Event festlegen (optional)",
  "Replay price after the event": "Preis der Aufzeichnung nach dem Event",
  "Use ticket price": "Ticketpreis verwenden",
  "Once the event is over, new buyers pay this instead of the ticket price. You can also change any price at any time.": "Nach dem Event zahlen neue Käufer diesen Preis statt des Ticketpreises. Du kannst jeden Preis auch jederzeit ändern.",
  "Add fees at checkout (buyers pay the fees)": "Gebühren bei der Bezahlung aufschlagen (Käufer zahlen die Gebühren)",
  "Buyers pay one combined EventLive + card processing fee on top of your price, so you receive the full amount you set (card fees are estimated at the standard rate — unusual cards may vary slightly).": "Käufer zahlen zusätzlich zu deinem Preis eine kombinierte Gebühr für EventLive und die Kartenzahlung, sodass du den vollen festgelegten Betrag erhältst (Kartengebühren werden zum Standardsatz geschätzt – bei ungewöhnlichen Karten kann es leicht abweichen).",
  "Fees are currently deducted from your price: the EventLive fee shown above plus Stripe's card processing fee.": "Die Gebühren werden derzeit von deinem Preis abgezogen: die oben angezeigte EventLive-Gebühr plus die Kartengebühr von Stripe.",
  "Default Price Suggestions": "Preisvorschläge",
  "These are suggested amounts customers will see, but they can enter any amount they wish.": "Diese Beträge werden Kunden vorgeschlagen, sie können aber jeden beliebigen Betrag eingeben.",
  "More settings": "Weitere Einstellungen",
  "Upload logo in Profile Settings": "Logo in den Profileinstellungen hochladen",
  "Invite free viewers in Guest List": "Kostenlose Zuschauer über die Gästeliste einladen",
  "Customize event branding": "Event-Branding anpassen",
  "Enable payment emails in Stripe": "Zahlungs-E-Mails in Stripe aktivieren",
  "Customize branding in Stripe": "Branding in Stripe anpassen",
  "Credits Added Successfully": "Credits erfolgreich hinzugefügt",
  "Thank You for Your Purchase!": "Danke für deinen Kauf!",
  "Your credits are ready to use. You can now:": "Deine Credits sind bereit. Du kannst jetzt:",
  "You can now:": "Du kannst jetzt:",
  "Use your credits to unlock more events": "Deine Credits nutzen, um weitere Events freizuschalten",
  "Check your available balance before your next purchase": "Vor deinem nächsten Kauf dein verfügbares Guthaben prüfen",
  "Return to your events and keep editing": "Zu deinen Events zurückkehren und weiter bearbeiten",
  "Invite guests to your event by sharing the event link or using the Guest List feature": "Gäste zu deinem Event einladen, indem du den Event-Link teilst oder die Gästeliste nutzt",
  "Open \"How to Go Live\" for a step-by-step guide": "„So gehst du live“ öffnen, um eine Schritt-für-Schritt-Anleitung zu sehen",
  "Go live on the day of your event": "Am Tag deines Events live gehen",
  "Return to Event": "Zurück zum Event",
  "View My Events": "Meine Events ansehen",
  "Afghanistan": "Afghanistan",
  "Åland Islands": "Ålandinseln",
  "Albania": "Albanien",
  "Algeria": "Algerien",
  "American Samoa": "Amerikanisch-Samoa",
  "Andorra": "Andorra",
  "Angola": "Angola",
  "Anguilla": "Anguilla",
  "Antarctica": "Antarktis",
  "Antigua and Barbuda": "Antigua und Barbuda",
  "Argentina": "Argentinien",
  "Armenia": "Armenien",
  "Aruba": "Aruba",
  "Australia": "Australien",
  "Austria": "Österreich",
  "Azerbaijan": "Aserbaidschan",
  "Bahamas": "Bahamas",
  "Bahrain": "Bahrain",
  "Bangladesh": "Bangladesch",
  "Belgium": "Belgien",
  "Belize": "Belize",
  "Benin": "Benin",
  "Bermuda": "Bermuda",
  "Bhutan": "Bhutan",
  "Bolivia": "Bolivien",
  "Bosnia and Herzegovina": "Bosnien und Herzegowina",
  "Botswana": "Botsuana",
  "Bouvet Island": "Bouvetinsel",
  "Brazil": "Brasilien",
  "British Indian Ocean Territory": "Britisches Territorium im Indischen Ozean",
  "Brunei Darussalam": "Brunei Darussalam",
  "Bulgaria": "Bulgarien",
  "Burkina Faso": "Burkina Faso",
  "Burundi": "Burundi",
  "Cambodia": "Kambodscha",
  "Cameroon": "Kamerun",
  "Canada": "Kanada",
  "Cape Verde": "Cabo Verde",
  "Cayman Islands": "Kaimaninseln",
  "Central African Republic": "Zentralafrikanische Republik",
  "Chad": "Tschad",
  "Chile": "Chile",
  "China": "China",
  "Christmas Island": "Weihnachtsinsel",
  "Cocos (Keeling) Islands": "Kokosinseln",
  "Colombia": "Kolumbien",
  "Comoros": "Komoren",
  "Congo": "Kongo-Brazzaville",
  "Congo, The Democratic Republic of the": "Kongo-Kinshasa",
  "Cook Islands": "Cookinseln",
  "Costa Rica": "Costa Rica",
  "Cote D Ivoire": "Côte d’Ivoire",
  "Croatia": "Kroatien",
  "Cuba": "Kuba",
  "Cyprus": "Zypern",
  "Czech Republic": "Tschechien",
  "Denmark": "Dänemark",
  "Djibouti": "Dschibuti",
  "Dominica": "Dominica",
  "Dominican Republic": "Dominikanische Republik",
  "Ecuador": "Ecuador",
  "Egypt": "Ägypten",
  "El Salvador": "El Salvador",
  "Equatorial Guinea": "Äquatorialguinea",
  "Eritrea": "Eritrea",
  "Estonia": "Estland",
  "Ethiopia": "Äthiopien",
  "Falkland Islands (Malvinas)": "Falklandinseln",
  "Faroe Islands": "Färöer",
  "Fiji": "Fidschi",
  "Finland": "Finnland",
  "France": "Frankreich",
  "French Guiana": "Französisch-Guayana",
  "French Polynesia": "Französisch-Polynesien",
  "French Southern Territories": "Französische Süd- und Antarktisgebiete",
  "Gabon": "Gabun",
  "Gambia": "Gambia",
  "Georgia": "Georgien",
  "Germany": "Deutschland",
  "Ghana": "Ghana",
  "Gibraltar": "Gibraltar",
  "Greece": "Griechenland",
  "Greenland": "Grönland",
  "Grenada": "Grenada",
  "Guadeloupe": "Guadeloupe",
  "Guam": "Guam",
  "Guatemala": "Guatemala",
  "Guernsey": "Guernsey",
  "Guinea": "Guinea",
  "Guinea-Bissau": "Guinea-Bissau",
  "Guyana": "Guyana",
  "Haiti": "Haiti",
  "Heard Island and Mcdonald Islands": "Heard und McDonaldinseln",
  "Holy See (Vatican City State)": "Vatikanstadt",
  "Honduras": "Honduras",
  "Hong Kong": "Hongkong",
  "Hungary": "Ungarn",
  "Iceland": "Island",
  "India": "Indien",
  "Indonesia": "Indonesien",
  "Iran, Islamic Republic Of": "Iran",
  "Iraq": "Irak",
  "Ireland": "Irland",
  "Isle of Man": "Isle of Man",
  "Israel": "Israel",
  "Italy": "Italien",
  "Jamaica": "Jamaika",
  "Japan": "Japan",
  "Jersey": "Jersey",
  "Jordan": "Jordanien",
  "Kazakhstan": "Kasachstan",
  "Kenya": "Kenia",
  "Kiribati": "Kiribati",
  "Korea, Democratic People Republic of": "Nordkorea",
  "Korea, Republic of": "Südkorea",
  "Kuwait": "Kuwait",
  "Kyrgyzstan": "Kirgisistan",
  "Lao People Democratic Republic": "Laos",
  "Latvia": "Lettland",
  "Lebanon": "Libanon",
  "Lesotho": "Lesotho",
  "Liberia": "Liberia",
  "Libyan Arab Jamahiriya": "Libyen",
  "Liechtenstein": "Liechtenstein",
  "Lithuania": "Litauen",
  "Luxembourg": "Luxemburg",
  "Macao": "Macau",
  "Macedonia, The Former Yugoslav Republic of": "Nordmazedonien",
  "Madagascar": "Madagaskar",
  "Malawi": "Malawi",
  "Malaysia": "Malaysia",
  "Maldives": "Malediven",
  "Mali": "Mali",
  "Malta": "Malta",
  "Marshall Islands": "Marshallinseln",
  "Martinique": "Martinique",
  "Mauritania": "Mauretanien",
  "Mauritius": "Mauritius",
  "Mayotte": "Mayotte",
  "Mexico": "Mexiko",
  "Micronesia, Federated States of": "Mikronesien",
  "Moldova, Republic of": "Republik Moldau",
  "Monaco": "Monaco",
  "Mongolia": "Mongolei",
  "Montserrat": "Montserrat",
  "Morocco": "Marokko",
  "Mozambique": "Mosambik",
  "Myanmar": "Myanmar",
  "Namibia": "Namibia",
  "Nauru": "Nauru",
  "Nepal": "Nepal",
  "Netherlands": "Niederlande",
  "Netherlands Antilles": "Niederländische Antillen",
  "New Caledonia": "Neukaledonien",
  "New Zealand": "Neuseeland",
  "Nicaragua": "Nicaragua",
  "Niger": "Niger",
  "Nigeria": "Nigeria",
  "Niue": "Niue",
  "Norfolk Island": "Norfolkinsel",
  "Northern Mariana Islands": "Nördliche Marianen",
  "Norway": "Norwegen",
  "Oman": "Oman",
  "Pakistan": "Pakistan",
  "Palau": "Palau",
  "Palestinian Territory, Occupied": "Palästina",
  "Panama": "Panama",
  "Papua New Guinea": "Papua-Neuguinea",
  "Paraguay": "Paraguay",
  "Peru": "Peru",
  "Philippines": "Philippinen",
  "Pitcairn": "Pitcairninseln",
  "Poland": "Polen",
  "Portugal": "Portugal",
  "Puerto Rico": "Puerto Rico",
  "Qatar": "Katar",
  "Reunion": "Réunion",
  "Romania": "Rumänien",
  "Russian Federation": "Russland",
  "RWANDA": "Ruanda",
  "Saint Helena": "St. Helena",
  "Saint Kitts and Nevis": "St. Kitts und Nevis",
  "Saint Lucia": "St. Lucia",
  "Saint Pierre and Miquelon": "St. Pierre und Miquelon",
  "Saint Vincent and the Grenadines": "St. Vincent und die Grenadinen",
  "Samoa": "Samoa",
  "San Marino": "San Marino",
  "Sao Tome and Principe": "São Tomé und Príncipe",
  "Saudi Arabia": "Saudi-Arabien",
  "Senegal": "Senegal",
  "Serbia and Montenegro": "Serbien und Montenegro",
  "Seychelles": "Seychellen",
  "Sierra Leone": "Sierra Leone",
  "Singapore": "Singapur",
  "Slovakia": "Slowakei",
  "Slovenia": "Slowenien",
  "Solomon Islands": "Salomonen",
  "Somalia": "Somalia",
  "South Africa": "Südafrika",
  "South Georgia and the South Sandwich Islands": "Südgeorgien und die Südlichen Sandwichinseln",
  "Spain": "Spanien",
  "Sri Lanka": "Sri Lanka",
  "Sudan": "Sudan",
  "Suriname": "Suriname",
  "Svalbard and Jan Mayen": "Spitzbergen und Jan Mayen",
  "Swaziland": "Eswatini",
  "Sweden": "Schweden",
  "Switzerland": "Schweiz",
  "Syrian Arab Republic": "Syrien",
  "Taiwan, Province of China": "Taiwan",
  "Tajikistan": "Tadschikistan",
  "Tanzania, United Republic of": "Tansania",
  "Thailand": "Thailand",
  "Timor-Leste": "Timor-Leste",
  "Togo": "Togo",
  "Tokelau": "Tokelau",
  "Tonga": "Tonga",
  "Trinidad and Tobago": "Trinidad und Tobago",
  "Tunisia": "Tunesien",
  "Turkey": "Türkei",
  "Turkmenistan": "Turkmenistan",
  "Turks and Caicos Islands": "Turks- und Caicosinseln",
  "Tuvalu": "Tuvalu",
  "Uganda": "Uganda",
  "Ukraine": "Ukraine",
  "United Arab Emirates": "Vereinigte Arabische Emirate",
  "United Kingdom": "Vereinigtes Königreich",
  "United States": "Vereinigte Staaten",
  "United States Minor Outlying Islands": "Amerikanische Überseeinseln",
  "Uruguay": "Uruguay",
  "Uzbekistan": "Usbekistan",
  "Vanuatu": "Vanuatu",
  "Venezuela": "Venezuela",
  "Viet Nam": "Vietnam",
  "Virgin Islands, British": "Britische Jungferninseln",
  "Virgin Islands, U.S.": "Amerikanische Jungferninseln",
  "Wallis and Futuna": "Wallis und Futuna",
  "Western Sahara": "Westsahara",
  "Yemen": "Jemen",
  "Zambia": "Sambia",
  "Zimbabwe": "Simbabwe",
  "Your client's account · used for {count} event": {
    "one": "Konto deines Kunden · für {count} Event verwendet",
    "other": "Konto deines Kunden · für {count} Events verwendet"
  },
  "Your client's account": "Konto deines Kunden",
  "Your account · used for {count} event": {
    "one": "Dein Konto · für {count} Event verwendet",
    "other": "Dein Konto · für {count} Events verwendet"
  },
  "Your account": "Dein Konto",
  "Used for {count} event": {
    "one": "Für {count} Event verwendet",
    "other": "Für {count} Events verwendet"
  },
  "Connected before": "Bereits verbunden",
  "Ticket payouts for “{event}” will go to {account}, your client's Stripe account. Use it only for this client's events.": "Die Ticketeinnahmen für „{event}“ gehen an {account}, das Stripe-Konto deines Kunden. Verwende es nur für die Events dieses Kunden.",
  "Ticket payouts for “{event}” will go to {account}.": "Die Ticketeinnahmen für „{event}“ gehen an {account}.",
  "Use this account": "Dieses Konto verwenden",
  "Couldn't use this Stripe account": "Dieses Stripe-Konto konnte nicht verwendet werden",
  "Use a Stripe account you've connected before": "Verwende ein Stripe-Konto, das du bereits verbunden hast",
  "Or connect another Stripe account:": "Oder verbinde ein anderes Stripe-Konto:",
  "Connect another Stripe account": "Anderes Stripe-Konto verbinden"
}
